import { useCallback, useRef } from 'react'
import { Unsubscribe } from 'firebase/firestore'

const noop = () => {}
export const useUnsubscribe = () => {
  const unsubscribeRef = useRef(noop)
  const unsubscribe = useCallback(() => {
    unsubscribeRef.current()
  }, [])
  const clearUnsubscribe = useCallback(() => {
    unsubscribeRef.current = noop
  }, [])
  const registerUnsubscribe = useCallback(
    (unsubscribe: Unsubscribe) => {
      const nextUnsubscribe = unsubscribeRef.current
      unsubscribeRef.current = () => {
        unsubscribe()
        nextUnsubscribe()
        if (nextUnsubscribe === noop) {
          clearUnsubscribe()
        }
      }
    },
    [clearUnsubscribe],
  )
  return {
    unsubscribe,
    registerUnsubscribe,
  }
}
